import _ from "lodash";
import {FieldErrors, FieldPath, FieldValues, UseFormRegister} from "react-hook-form";
import {TextField, TextFieldProps} from "@mui/material";

export interface Props<TFieldValues extends FieldValues = FieldValues> {
    name: FieldPath<TFieldValues>;
    placeholder?: string;
    type?: "text" | "number" | "password";
    register: UseFormRegister<TFieldValues>;
    errors: FieldErrors<TFieldValues>;
    disabled?: boolean;
    inputProps?: Partial<TextFieldProps>;
    multiline?: boolean;
    rows?: number;
}

export const TextInput = <TFieldValues extends FieldValues = FieldValues>(props: Props<TFieldValues>) => {
    const {name, placeholder, type, register, errors, disabled, inputProps, multiline, rows} = props;
    return (
        <TextField
            {...inputProps}
            InputProps={{
                disableUnderline: true,
            }}
            placeholder={placeholder}
            multiline={multiline}
            rows={rows}
            hiddenLabel
            margin="none"
            size="small"
            id={name}
            data-test={name}
            //If type is passed as number we set it as text.
            type={type === "number" ? "text" : type}
            fullWidth
            variant="filled"
            disabled={disabled ?? false}
            {...register(name, {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                setValueAs: (value: string | null) => {
                    if (value === null) {
                        return null;
                    }
                    if (type === "number") {
                        if (value === "") {
                            return null;
                        }
                        return parseFloat(value);
                    }
                    return value;
                },
            })}
            error={!!_.get(errors, name)}
            helperText={_.get(errors, name)?.message as string}
        />
    );
};
